import { createColorVariable as r, createBorder as c, createOutline as s } from "./highrise530.mjs";
function a(e) {
  return {
    color: r(e, 50),
    border: c(e, 50),
    textColor: r(e, 700),
    rippleColor: r(e, 600),
    // Hover
    colorHover: r(e, 100),
    borderHover: c(e, 100),
    textColorHover: r(e, 800),
    // Focus
    colorFocus: r(e, 100),
    borderFocus: c(e, 200),
    textColorFocus: r(e, 700),
    outlineFocus: s(e, 100),
    // Pressed
    colorPressed: r(e, 200),
    borderPressed: c(e, 300),
    textColorPressed: r(e, 900),
    // Disabled
    colorDisabled: r(e, 25),
    borderDisabled: c(e, 25),
    textColorDisabled: r(e, 300)
  };
}
export {
  a as createTertiaryTheme
};
